module.exports = __webpack_public_path__ + "img/8.679b03b4.png";